import { makeStyles, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import GalleryPopupActions from 'components/atoms/buttons/popup/GalleryPopupActions';
import GalleryPopupContent from 'components/atoms/buttons/popup/GalleryPopupContent';
import GalleryPopupTitle from 'components/atoms/buttons/popup/GalleryPopupTitle';
import { GalleryContext } from 'context/gallery/GalleryContext';
import React, { useContext, useState } from 'react';
import FolderTree from './FolderTree';
import ImagesBlock from './ImagesBlock';
import UploadBlock from './UploadBlock';

const useStyles = makeStyles(() => ({
    popup: {
        width: '95vw',
        minHeight: '100%',
    },
    whiteButton: {
        borderColor: 'white',
        color: 'white',
    },
}));

const ColorButton = withStyles(() => ({
    root: {
        color: 'white',
        border: '1px solid rgba(255,255,255,0.35)',
    },
}))(Button);

const GalleryPopup = ({ white }: { white?: boolean }) => {
    const classes = useStyles();
    const { state, setGalleryState } = useContext(GalleryContext);
    const [file, setFile] = useState<string>('');

    const handleClickOpen = () => {
        setGalleryState({ ...state, openGallery: true, isUploading: false });
    };

    const handleClose = () => {
        setGalleryState({ ...state, openGallery: false, isUploading: false });
    };

    const handleFileSelection = (url: string) => {
        const fullUrl = `${state.breadcrumbs === '/' ? '' : state.breadcrumbs}/${url.substr(0, url.lastIndexOf('.'))}`;
        setFile(fullUrl);
    };

    const handleFileSelect = () => {
        return setGalleryState({ ...state, openGallery: false, selectedFile: file });
    };

    return (
        <div>
            {white ? (
                <ColorButton variant='outlined' onClick={handleClickOpen}>
                    Open gallery{' '}
                </ColorButton>
            ) : (
                <Button variant='outlined' color='primary' onClick={handleClickOpen}>
                    Open gallery
                </Button>
            )}
            <Dialog
                onClose={handleClose}
                aria-labelledby='customized-dialog-title'
                open={state.openGallery}
                maxWidth={false}
            >
                <GalleryPopupTitle
                    id='customized-dialog-title'
                    onClose={handleClose}
                    toggleUpload={() => setGalleryState({ ...state, isUploading: !state.isUploading })}
                    isUploading={state.isUploading}
                >
                    Gallery
                </GalleryPopupTitle>
                {state.isUploading && <UploadBlock />}
                <GalleryPopupContent dividers className={classes.popup}>
                    {state.openGallery ? <FolderTree /> : null}
                    <ImagesBlock handleFileSelection={handleFileSelection} />
                </GalleryPopupContent>
                <GalleryPopupActions>
                    <Button autoFocus onClick={handleClose} color='secondary'>
                        Close
                    </Button>
                    <Button autoFocus onClick={handleFileSelect} variant='contained' color='primary'>
                        Select file
                    </Button>
                </GalleryPopupActions>
            </Dialog>
        </div>
    );
};

export default GalleryPopup;
